import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpuFormWrapperComponent } from '../../components/spu-form-wrapper/spu-form-wrapper.component';
import { 
  SpuFormConfig,
  SPU_VIEW_MODE_HEADER_ACTIONS,
  SPU_PROPERTY_TABLE_SECTION,
  createSpuFormFields,
} from '../../spu.config';

@Component({
  selector: 'app-ordinary-spu-view',
  standalone: true,
  imports: [SpuFormWrapperComponent],
  templateUrl: './ordinary-spu-view.component.html',
  styleUrls: ['./ordinary-spu-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdinarySpuViewComponent {
  private translateService = inject(TranslateService);
  
  config: SpuFormConfig = {
    title: this.translateService.instant('goods.spu.form.titles.view_standard_product'),
    formFields: createSpuFormFields(false, this.translateService),
    tableSections: [SPU_PROPERTY_TABLE_SECTION],
    headerActions: SPU_VIEW_MODE_HEADER_ACTIONS, // Use view mode actions from config
    listRoute: '/goods/spu/ordinary',
    spuType: 'ordinary',
  };
}
